export default theme => ({
  page_footer: {
    top: "auto",
    bottom: 0,
  },
  page_footer_toolbar: {
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexFlow: "row wrap",
    margin: 3,
  },
});
